import {Pipe, PipeTransform} from '@angular/core'
import {Vendors} from '../vendor.items/list/list.service'
import {environment} from '../../../environments/environment'
import {Owner} from './dashboard.component'

@Pipe({
    name: 'filtViByCategory',
    pure: false,
    standalone: false
})
export class FilterVendorItemByCategoryPipe implements PipeTransform {
  transform(vis: Vendors[], category: string): Vendors[] {
    return vis.filter(vi => {
      if (['hotel', 'hotels'].includes(category)) {
        return environment.compareVendorCategory(vi.vendor.category, 'hotel') || environment.compareVendorCategory(vi.vendor.category, 'hotels')
      } else {
        return environment.compareVendorCategory(vi.vendor.category, category)
      }
    })
  }
}

@Pipe({
    name: 'notFilled',
    pure: false,
    standalone: false
})
export class NotFilledPipe implements PipeTransform {
  transform(vis: Vendors[]): boolean {
    return vis.filter(vi => {
      return (vi.vendorFlags.noRateLevels || vi.vendorFlags.noSchedules || vi.vendorFlags.noAllotments)
    }).length > 0
  }
}



@Pipe({
    name: 'dbAdminSearch',
    pure: true,
    standalone: false
})
export class DbAdminSearchPipe implements PipeTransform {
  transform(
    AL: {[key: string]: Owner},
    term: string,
    by: string,
    fAllAsWell: boolean,
    fUnfinished: boolean,
    fEmpty: boolean,
    fPending: boolean,
    fActive: boolean,
    fInactive: boolean
  ){
    const newList: {[key: string]: Owner} = {}
    term = (term) ? term.toLowerCase() : term

    for (const owner of Object.keys(AL)) {
      if (
        (AL[owner].status === 'E' && fEmpty) ||
        (AL[owner].status === 'OK' && fAllAsWell) ||
        (AL[owner].status === 'U' && fUnfinished) ||
        (AL[owner].status === 'P' && fPending) &&
        (
          (AL[owner].active && fActive) || (!AL[owner].active && fInactive)
        )
      ) {
        if (fActive && !fInactive && !AL[owner].active) {
          continue
        }
        if (!fActive && fInactive && AL[owner].active) {
          continue
        }
        if (!fActive && !fInactive) {
          continue
        }
        if (term) {
          if (by === 'C') {
            // Search by Company Name
            // if (owner.toLowerCase().includes(term)) {
            if (AL[owner].name.toLowerCase().includes(term)) {
              newList[owner] = AL[owner]
            }
          } else {
            // Search by Vendor Name
            if (AL[owner].names.toString().toLowerCase().includes(term)) {
              newList[owner] = AL[owner]
            }
          }
        } else {
          newList[owner] = AL[owner]
        }
      }
    }
    return newList
  }
}
